
{
  "loading": "Loading...",
  "login": {
    "title": "Log In",
    "description": "Welcome back! Please sign in to your account",
    "email": "Email",
    "emailPlaceholder": "Enter your email",
    "password": "Password",
    "passwordPlaceholder": "Enter your password",
    "submit": "Log In",
    "loginButton": "Log In",
    "loggingIn": "Logging in...",
    "forgotPassword": "Forgot your password?"
  },
  "signup": {
    "title": "Sign Up",
    "description": "Create your account to get started",
    "firstName": "First Name",
    "firstNamePlaceholder": "Enter your first name",
    "lastName": "Last Name",
    "lastNamePlaceholder": "Enter your last name",
    "name": "Full Name",
    "namePlaceholder": "Enter your full name",
    "email": "Email",
    "emailPlaceholder": "Enter your email",
    "password": "Password",
    "passwordPlaceholder": "Enter your password",
    "confirmPassword": "Confirm Password",
    "confirmPasswordPlaceholder": "Confirm your password",
    "submit": "Create Account",
    "signupButton": "Create Account",
    "createAccountButton": "Create Account",
    "signingUp": "Creating account...",
    "creatingAccount": "Creating account...",
    "terms": "I agree to the Terms of Service and Privacy Policy"
  },
  "forgotPassword": {
    "title": "Reset Password",
    "description": "Enter your email to receive a password reset link",
    "email": "Email",
    "emailPlaceholder": "Enter your email",
    "submit": "Send Reset Link",
    "sendResetButton": "Send Reset Link",
    "sendingReset": "Sending reset link...",
    "success": "Password reset link sent to your email",
    "error": "Failed to send reset link",
    "backToLogin": "Back to Login"
  },
  "resetPassword": {
    "title": "Set New Password",
    "description": "Enter your new password",
    "password": "New Password",
    "passwordPlaceholder": "Enter new password",
    "confirmPassword": "Confirm New Password",
    "confirmPasswordPlaceholder": "Confirm new password",
    "submit": "Update Password",
    "resetButton": "Update Password",
    "resetting": "Updating password...",
    "success": "Password has been successfully updated",
    "error": "Failed to update password",
    "updatingPassword": "Updating password...",
    "updatePasswordButton": "Update Password",
    "backToLogin": "Back to Login"
  },
  "socialAuth": {
    "orDivider": "Or continue with",
    "continueWithGoogle": "Continue with Google"
  },
  "validation": {
    "emailRequired": "Email is required",
    "emailInvalid": "Please enter a valid email address",
    "passwordRequired": "Password is required",
    "passwordTooShort": "Password must be at least 6 characters",
    "passwordMinLength": "Password must be at least 6 characters",
    "passwordsDoNotMatch": "Passwords do not match",
    "nameRequired": "Name is required",
    "firstNameRequired": "First name is required",
    "lastNameRequired": "Last name is required"
  },
  "languageNote": "Please note: All listings and communications are primarily in English."
}
